import React from 'react'
import { bool, string } from 'prop-types'
import { FormattedMessage } from 'react-intl'

import { tangoFooter } from '@assets'

import getCurrentYear from '@client/utils/date'

import useInternationalization from '@hooks/useInternationalization'
import * as FooterStyle from './Footer.style'

export default function Footer({ company, showFooterImage }) {
  const { country } = useInternationalization()

  return (
    <>
      <FooterStyle.Main>
        <FooterStyle.Container>
          <FooterStyle.Box>
            <FormattedMessage id="smb_acquisition_footer.new.title" />
          </FooterStyle.Box>
          <FooterStyle.Subtitle>
            <FormattedMessage id="smb_acquisition_footer.new.subtitle" />
          </FooterStyle.Subtitle>
          {showFooterImage && <FooterStyle.FooterImage src={tangoFooter} />}
        </FooterStyle.Container>
      </FooterStyle.Main>

      <FooterStyle.Rights>
        <FooterStyle.Container>
          <FooterStyle.Box>
            <FooterStyle.ReCaptchaRights>
              <FormattedMessage
                id="smb_acquisition_footer.recaptcha"
                values={{
                  a: (...chunks) => (
                    <a
                      href={
                        chunks[0][0] === 'Privacy Policy'
                          ? `https://www.gympass.com/${country}/privacy`
                          : `https://www.gympass.com/${country}/terms`
                      }
                    >
                      {chunks}
                    </a>
                  ),
                }}
              />
            </FooterStyle.ReCaptchaRights>

            <FooterStyle.GympassRights>
              &copy; 2012-{getCurrentYear()} {company}. -{' '}
              <FormattedMessage id="smb_acquisition_footer.rights" />
            </FooterStyle.GympassRights>
          </FooterStyle.Box>
        </FooterStyle.Container>
      </FooterStyle.Rights>
    </>
  )
}

Footer.propTypes = {
  company: string,
  showFooterImage: bool,
}

Footer.defaultProps = {
  company: 'GPBR Part. Ltda.',
  showFooterImage: true,
}
